import type { RouteRecordRaw } from 'vue-router'
import  DemoPage  from '../../pages/DemoPage.vue'
import {ROUTES} from '@myorg/type-lib'


export const DemoRoute: RouteRecordRaw = {
  path: ROUTES.DEMO.PATH,
  name: ROUTES.DEMO.NAME,
  component: DemoPage,
}
